"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _bwcOrder = require("@/api/selfOfficialOrder/bwcOrder");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OfficialOrder',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 20,
      queryData: {
        orderNo: '',
        memberId: '',
        mobile: '',
        storeName: '',
        takeoutOrderNo: '',
        locate: '',
        isPraise: '',
        platformCode: '',
        orderStatus: ''
      },
      applyTimeRange: null,
      takeoutSubmitTimeRange: null,
      createTimeRange: null,
      checkList: ['下单用户', '手机号码', '店铺名称', '下单平台', '外卖单号', '订单金额', '用户返现金额', '平台收益', '定位', '订单类型', '下单时间', '抢单时间', '创建时间', '更新时间']
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    onInquire: function onInquire() {
      this.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.queryData = {
        orderNo: '',
        memberId: '',
        mobile: '',
        storeName: '',
        takeoutOrderNo: '',
        locate: '',
        isPraise: '',
        platformCode: '',
        orderStatus: ''
      };
      this.applyTimeRange = null;
      this.takeoutSubmitTimeRange = null;
      this.createTimeRange = null;
      this.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this = this;
        var params, queryKeys, res, data, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              params = {
                page: this.page,
                size: this.size,
                sourceType: 2
              };
              queryKeys = ['orderNo', 'memberId', 'mobile', 'storeName', 'takeoutOrderNo', 'locate', 'isPraise', 'platformCode', 'orderStatus'];
              queryKeys.forEach(function (key) {
                if (_this.queryData[key] !== '' && _this.queryData[key] !== null && _this.queryData[key] !== undefined) {
                  params[key] = _this.queryData[key];
                }
              });
              if (this.applyTimeRange && this.applyTimeRange.length === 2) {
                params.applyTimeStart = this.applyTimeRange[0];
                params.applyTimeEnd = this.applyTimeRange[1];
              }
              if (this.takeoutSubmitTimeRange && this.takeoutSubmitTimeRange.length === 2) {
                params.takeoutSubmitTimeStart = this.takeoutSubmitTimeRange[0];
                params.takeoutSubmitTimeEnd = this.takeoutSubmitTimeRange[1];
              }
              if (this.createTimeRange && this.createTimeRange.length === 2) {
                params.createTimeStart = this.createTimeRange[0];
                params.createTimeEnd = this.createTimeRange[1];
              }
              _context.n = 2;
              return (0, _bwcOrder.queryBwcOrderPage)(params);
            case 2:
              res = _context.v;
              data = res.data || {};
              this.tableData = data.data || [];
              this.total = data.total || 0;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('查询霸王餐订单失败', _t);
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    formatPlatform: function formatPlatform(code) {
      var map = {
        mt: '美团',
        ele: '淘宝闪购'
      };
      return map[code] || code || '-';
    },
    formatOrderStatus: function formatOrderStatus(status) {
      var map = {
        '-4': '支付不足已取消',
        '-2': '超时取消',
        '-1': '已取消',
        0: '已报名，待下单',
        1: '已下单，待评价',
        2: '审核中',
        3: '已完成'
      };
      return map[status] || status || '-';
    },
    statusType: function statusType(status) {
      var typeMap = {
        '-6': 'success',
        '-3': 'danger',
        '-1': 'info',
        0: '',
        1: 'warning',
        2: 'warning',
        3: 'success'
      };
      return typeMap[status] || '';
    },
    onCheckBox: function onCheckBox() {
      localStorage.setItem('officialOrder_Column', JSON.stringify(this.checkList));
    }
  },
  created: function created() {
    var saved = localStorage.getItem('officialOrder_Column');
    if (saved) {
      this.checkList = JSON.parse(saved);
    }
  }
};